'use strict';

const BrowserUtils = require('./BrowserUtils');

/**
 * Attaches or deattaches a callback from the resize change event
 * @param  {String}     actionType   determines whether to use addEventListener or removeEventListener
 * @param  {Function}   callback the handler to be attached
 */
function _handleResizeHandlerAttachment(actionType, callback) {
    var focusableElements = ['input', 'select', 'textarea'],
        body = document.getElementsByTagName('body')[0],
        action = actionType === 'add' ? HTMLElement.prototype.addEventListener : HTMLElement.prototype.removeEventListener,
        safeWindowsAction = actionType === 'add' ? window.addEventListener : window.removeEventListener,
        delegatedCallback = function (event) {
            var targetType = event.target.nodeName.toLowerCase();
            if (focusableElements.indexOf(targetType) > -1) {
                callback();
            }
        };

    if (BrowserUtils.isMobileNonIPad()) {
        action.call(body, 'focusin', delegatedCallback, false);
        action.call(body, 'focusout', delegatedCallback, false);
        action.call(document, 'orientationchange', callback, false);
    } else {
        safeWindowsAction.call(window, 'resize', callback, false);
    }
}

/**
 * Utility set of methods to handle the viewport properties.
 * @type {Object}
 */
const Viewport = {

    /**
     * Adds a handler to the viewport size change event, considering
     * also problematic cases in mobile devices
     * @callback  callback
     */
    onResize(callback) {
        _handleResizeHandlerAttachment('add', callback);
    },

    /**
     * Removes a handler off the viewport size change event
     * @callback  callback   the handler to be removed
     */
    offResize(callback) {
        _handleResizeHandlerAttachment('remove', callback);
    },

    isInsideViewport(el) {
        if (el && el.getBoundingClientRect) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        } else {
            false;
        }
    }

};


module.exports = Viewport;



/** WEBPACK FOOTER **
 ** ./src/utils/Viewport.js
 **/